import e from"react";import{Root as t}from"./styles.js";const r=({data:r,render:a,perPage:d,gap:n,index:o,testId:s})=>{const p={perPage:d||1,gap:n,index:o};return e.createElement(t,{"data-testid":s,ownerState:p},a(r))};export{r as default};
//# sourceMappingURL=CarouselSlide.js.map
